export const DESIGNER = 1;
export const OUTSOURCE_STUDIO = 2;
export const LIST = [
  { id: DESIGNER, name: 'Internal' },
  { id: OUTSOURCE_STUDIO, name: 'External' },
];
